export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Dashboard
  organizationSummary: '/dashboard/organization-summary',
  memberTokens: '/dashboard/member-tokens',
  sharePointSummary: '/dashboard/sharepoint-summary',
  
  // Members
  members: '/members',
  memberById: (id: number) => `/members/${id}`,
  
  // Activities
  activities: '/activities',
  memberActivities: (memberId: number) => `/activities/member/${memberId}`,
  
  // Categories
  categories: '/categories',
  categoryVersions: '/categories/versions',
  categoryVersionsByYear: (year: number) => `/categories/versions/${year}`,
  
  // Users
  users: '/users',
  userById: (id: number) => `/users/${id}`,
  
  // Token Ledgers
  tokenLedgers: '/token-ledgers',
  memberTransfers: (memberId: number) => `/token-ledgers/member/${memberId}`,
  
  // Health
  health: '/health',
  
  // Analytics
  analytics: '/dashboard/analytics',
  
  // Settings
  settings: '/settings',
  
  // Membership Fees
  memberFeeStatus: (memberId: number) => `/membership-fees/member/${memberId}/status`,
  membershipPayments: '/membership-fees/payments',
  membershipFees: '/membership-fees',
  recordPayment: '/membership-fees/record-payment',
  organizationFeeSummary: '/membership-fees/organization/summary',
  memberActivitiesByTracker: (memberId: number) => `/membership-fees/member/${memberId}/activities-by-tracker`,
  trackerActivitiesByMember: (trackerName: string) => `/membership-fees/tracker/${trackerName}/activities`,
  updateMustDoStatus: (memberId: number) => `/membership-fees/member/${memberId}/must-do-status`,
  
  // Tracker Dashboard
  trackersSummary: '/tracker-dashboard/trackers/summary',
  trackerRecords: (trackerName: string) => `/tracker-dashboard/tracker/${trackerName}/records`,
  trackerActivityStats: (trackerName: string) => `/tracker-dashboard/tracker/${trackerName}/activities`,
  memberTrackerView: (memberId: number) => `/tracker-dashboard/member/${memberId}/tracker-view`,
  compulsoryActivitiesStatus: '/tracker-dashboard/compulsory-activities/status',
  trackerStats: '/tracker-dashboard/stats',
  trackerActivitiesAlt: '/tracker-dashboard/activities',
  trackerPerformance: '/tracker-dashboard/performance',
  
  // Audit endpoints
  auditLogs: '/audit/logs',
  auditSummary: '/audit/summary',
  auditExport: '/audit/export/csv',
  auditSearch: '/audit/search',
  
  // Data management endpoints
  dataExport: '/data/export',
  dataImport: '/data/import',
  dataTemplates: '/data/export-templates',
};